<footer>
  <h1>
    Built with <img src="/images/emojis/heart.png" alt="Heart" /> by Moksha Data
    Studio, Data to Dream, and ACLU TX
  </h1>
  <h2>
    Share this site on
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="https://twitter.com/intent/tweet?text=👋 I just learned about the Houston Budget and made my voice heard at&url=https://houstonbudget.cool&hashtags=HouBudget&original_referer=https://houstonbudget.cool"
      >Twitter <img src="/images/emojis/bird.png" alt="Bird emoji" /></a
    >,
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fhoustonbudget.cool"
      >Facebook <img src="/images/emojis/books.png" alt="Books emoji" /></a
    >, or
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="mailto:?subject=Budget Engagement&body=Check out this cool tool I just used to learn about the Houston Budget and make my voice heard: https://houstonbudget.cool"
      >email <img src="/images/emojis/email.png" alt="Mail emoji" /></a
    >.
  </h2>
</footer>

<style>
  footer {
    width: 100%;
    min-height: 15vh;
    padding: 2.5vh 1rem;
    background-color: transparent;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    color: var(--accent-color);
    font-size: 2rem;
    font-weight: 200;
    flex-direction: column;
    z-index: 1001;
    position: relative;
    background: var(--primary-color);
  }

  h1 {
    font-size: 1.35rem;
    margin-bottom: 0.5rem;
    font-weight: 500;
    font-family: var(--font-serif);
  }

  h2,
  h2 a {
    font-size: 0.9rem;
    text-transform: uppercase;
    font-weight: 500;
    color: #717171;
    letter-spacing: 0.025rem;
    transition: all 300ms ease;
  }

  a:hover {
    text-decoration: none;
    color: var(--accent-color);
  }

  img {
    height: 1em;
    width: auto;
    display: inline-block;
  }
</style>
